import angular from 'angular';
import ngEnter from './ng-enter';
import duration from './duration';
import maxMinutes from './max-minutes';
import minMinutes from './min-minutes';
import ngPlaceholder from './ng-placeholder';
import ngAvatar from './ng-avatar';
import entityName from './entity-name';
import decimalValue from './decimal-value';
import stopEnterPropagation from './stop-enter-propagation';
import wavesAttach from './waves-attach';
import circliful from './circliful';

const directives = angular.module('ttb.directives', [
    ngEnter,
    duration,
    maxMinutes,
    minMinutes,
    ngPlaceholder,
    ngAvatar,
    entityName,
    decimalValue,
    stopEnterPropagation,
    wavesAttach,
    circliful,
])
    .name;

export default directives;



// WEBPACK FOOTER //
// ../directives/index.js